module.exports = "//public.zight.com/packs/media/images/free_plan_icon-250aafec46d4bde92a8e3b6696d8237a.png";